import React from 'react';
import { Calendar, ChevronDown, Download, ChevronRight, ChevronLeft, Ticket, Settings2, Wallet } from 'lucide-react';
import './CouponActivityTab.css';

// ================== DATA (استبدلها بالداتا من الـ API) ==================
const activityRows = [
  {
    date: 'May 31, 2025', time: '10:45 am',
    user: 'Sarah Ahmed', role: 'Admin',
    action: 'Created Coupon',
    category: 'Budget',
    detailsLabel: 'Initial Value:', detailsValue: '500,000 EGP',
    ip: '197.168.1.12',
  },
  {
    date: 'May 31, 2025', time: '09:30 am',
    user: 'Sarah Ahmed', role: 'Admin',
    action: 'Updated Budget Limit',
    category: 'Budget',
    detailsLabel: 'Changed from:', detailsValue: '80,000 EGP to 100,000 EGP',
    ip: '197.168.1.12',
  },
  {
    date: 'May 30, 2025', time: '04:15 pm',
    user: 'Omar Hassan', role: 'Manager',
    action: 'Assigned to Provider',
    category: 'Assignment',
    detailsLabel: 'Provider:', detailsValue: 'Provider Co.',
    ip: '197.168.1.15',
  },
  {
    date: 'May 29, 2025', time: '02:20 pm',
    user: 'Ahmed Ali', role: 'Supervisor',
    action: 'Auto Pause Triggered',
    category: 'Rules',
    detailsLabel: 'Threshold reached:', detailsValue: '(95%)',
    ip: '197.168.1.21',
  },
  {
    date: 'May 27, 2025', time: '11:05 am',
    user: 'Sarah Ahmed', role: 'Admin',
    action: 'Resumed Budget',
    category: 'Rules',
    detailsLabel: 'Budget resumed', detailsValue: 'manually',
    ip: '197.168.1.12',
  },
  {
    date: 'May 26, 2025', time: '06:40 pm',
    user: 'System', role: 'System',
    action: 'Redemption Processed',
    category: 'Redemption',
    detailsLabel: 'Redemption ID: #RED-9821', detailsValue: 'Amount: 350 EGP',
    ip: '10.0.0.5',
  },
];

const categoryStyles = {
  Budget: { bg: '#F6E9FC', color: '#7E1BAD' },
  Assignment: { bg: '#F0F8FF', color: '#3E9FF6' },
  Rules: { bg: '#ECF9F7', color: '#0D9488' },
  Redemption: { bg: '#FFFAEA', color: '#B45309' },
};

const summaryStats = [
  { icon: Ticket, iconBg: '#ECF9F7', iconColor: '#3FBEAC', label: 'Total Activities', value: '48' },
  { icon: Wallet, iconBg: '#FFFAEA', iconColor: '#FEB91E', label: 'Budget Changes', value: '12' },
  { icon: Settings2, iconBg: '#F8F8F8', iconColor: '#696969', label: 'Rule Updates', value: '9' },
  { icon: Ticket, iconBg: '#E8F9EE', iconColor: '#04B22E', label: 'Redemptions', value: '27' },
];

const topUsers = [
  { initials: 'SA', name: 'Sarah Ahmed', role: 'Admin', count: 18, bg: '#F6E9FC', color: '#7E1BAD' },
  { initials: 'OH', name: 'Omar Hassan', role: 'Manager', count: 12, bg: '#F4F8F0', color: '#8CB369' },
  { initials: 'AA', name: 'Ahmed Ali', role: 'Supervisor', count: 8, bg: '#F0F8FF', color: '#3E9FF6' },
  { initials: 'SY', name: 'System', role: 'System', count: 10, bg: '#F8F8F8', color: '#696969' },
];

// ================== MAIN COMPONENT ==================
export default function CouponActivityTab() {
  return (
    <>
         {/* Header + Filters */}
      <div className="at-header-row">
          <div>
            <h3 className="at-title">Activity Log</h3>
            <p className="at-desc">Track all actions and changes made to this coupon's budget and settings.</p>
          </div>

          <div className="at-filters">
            <button className="at-filter-btn">
              <Calendar size={14} />
              Mar 10, 2025 - May 31, 2025
            </button>
            <button className="at-filter-btn">
              All Actions <ChevronDown size={14} />
            </button>
            <button className="at-filter-btn">
              All Users <ChevronDown size={14} />
            </button>
            <button className="at-export-btn">
              <Download size={14} /> Export
            </button>
          </div>
      </div>
      {/* ---------- MAIN COLUMN ---------- */}
       <div className="at-grid">
      <div className="at-main">
        {/* Table */}
        <div className="at-panel">
          <div className="at-table-wrap">
            <table className="at-table">
              <thead>
                <tr>
                  <th>Date & Time</th>
                  <th>User</th>
                  <th>Action</th>
                  <th>Category</th>
                  <th>Details</th>
                  <th>IP Address</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {activityRows.map((row, i) => {
                  const cat = categoryStyles[row.category];
                  return (
                    <tr key={i}>
                      <td>
                        <div className="at-datetime">
                          <span className="at-date">{row.date}</span>
                          <span className="at-time">{row.time}</span>
                        </div>
                      </td>
                      <td>
                        <div className="at-user">
                          <span className="at-user-name">{row.user}</span>
                          <span className="at-user-role">{row.role}</span>
                        </div>
                      </td>
                      <td>{row.action}</td>
                      <td>
                        <span className="at-cat-pill" style={{ backgroundColor: cat.bg, color: cat.color }}>
                          {row.category}
                        </span>
                      </td>
                      <td>
                        <div className="at-details">
                          <span className="at-details-label">{row.detailsLabel}</span>
                          <span className="at-details-value">{row.detailsValue}</span>
                        </div>
                      </td>
                      <td>{row.ip}</td>
                      <td>
                        <ChevronRight size={16} className="at-row-arrow" />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Footer / Pagination */}
          <div className="at-table-footer">
            <span className="at-showing-text">Showing 1 of 8 of 48 activities</span>

            <div className="at-pagination">
              <button className="at-page-select">
                10 per page <ChevronDown size={14} />
              </button>

              <button className="at-page-nav" disabled>
                <ChevronLeft size={16} />
              </button>
              <button className="at-page-num at-page-num-active">1</button>
              <button className="at-page-num">2</button>
              <button className="at-page-num">3</button>
              <span className="at-page-dots">...</span>
              <button className="at-page-num">10</button>
              <button className="at-page-nav">
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* ---------- SIDEBAR ---------- */}
      <div className="at-sidebar">
        {/* Activity Summary */}
        <div className="at-card">
          <h3 className="at-card-title">Activity Summary</h3>
          <p className="at-card-sub">May 20 - May 31, 2025</p>

          <div className="at-summary-grid">
            {summaryStats.map((s) => {
              const Icon = s.icon;
              return (
                <div className="at-summary-item" key={s.label}>
                  <span className="at-summary-icon" style={{ backgroundColor: s.iconBg }}>
                    <Icon size={16} color={s.iconColor} />
                  </span>
                  <div className="at-summary-text">
                    <span className="at-summary-value">{s.value}</span>
                    <span className="at-summary-label">{s.label}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {/* Top Users */}
        <div className="at-card">
          <h3 className="at-card-title">Top Users</h3>
          <div className="at-users-list">
            {topUsers.map((u) => (
              <div className="at-user-row" key={u.name}>
                <span className="at-user-avatar" style={{ backgroundColor: u.bg, color: u.color }}>
                  {u.initials}
                </span>
                <div className="at-user-info">
                  <span className="at-user-row-name">{u.name}</span>
                  <span className="at-user-row-role">{u.role}</span>
                </div>
                <div className="at-user-count-block">
                  <span className="at-user-count">{u.count}</span>
                  <span className="at-user-count-label">Activities</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </>
  );
}